import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalNav from '../components/LegalNav';
import './LegalPage.css';

function Contact() {
  useEffect(() => {
    document.title = 'Contact Us - My Fair Share UK Tax Calculator';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contact the My Fair Share team. Send us your questions, feedback, or suggestions about our free UK tax calculator.');
    }
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Calculator</Link>
        
        <h1>Contact Us</h1>
        <p className="last-updated">Last updated: November 2025</p>

        <section>
          <h2>Get In Touch</h2>
          <p>
            We welcome your questions, feedback, and suggestions about My Fair Share. 
            Please use the contact information below to reach us.
          </p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <div className="contact-details">
            <div className="contact-item">
              <h3>📧 Email</h3>
              <p>
                For general enquiries and support:<br />
                <a href="mailto:contact@myfairshare.org.uk">contact@myfairshare.org.uk</a>
              </p>
            </div>
            
            <div className="contact-item">
              <h3>🐛 Technical Issues</h3>
              <p>
                For reporting bugs or technical problems:<br />
                <a href="https://github.com/cowhub2/Wageapp/issues" target="_blank" rel="noopener noreferrer">
                  GitHub Issues
                </a>
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2>Response Times</h2>
          <p>
            We aim to respond to all enquiries within 5 working days. 
            Please note that this is a free tool and support is provided on a best-efforts basis.
          </p>
        </section>

        <section>
          <h2>Data Protection Enquiries</h2>
          <p>
            For questions about how we handle your data or to exercise your rights under 
            UK GDPR, please email us at{' '}
            <a href="mailto:privacy@myfairshare.org.uk">privacy@myfairshare.org.uk</a>.
          </p>
          <p>
            For more information about our data practices, please see our{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </section>

        <section>
          <h2>Complaints</h2>
          <p>
            If you are not satisfied with our response, you have the right to lodge a 
            complaint with the Information Commissioner's Office (ICO):
          </p>
          <ul>
            <li>Website: <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">ico.org.uk</a></li>
            <li>Telephone: 0303 123 1113</li>
          </ul>
        </section>

        <LegalNav excludeLinks={['/contact']} />
      </div>
    </div>
  );
}

export default Contact;
